import { render, staticRenderFns } from "./MeasureConfigs.vue?vue&type=template&id=efbdba1c&scoped=true&"
import script from "./MeasureConfigs.vue?vue&type=script&lang=js&"
export * from "./MeasureConfigs.vue?vue&type=script&lang=js&"
import style0 from "./MeasureConfigs.vue?vue&type=style&index=0&id=efbdba1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbdba1c",
  null
  
)

export default component.exports